module.exports = __webpack_public_path__ + "img/10.ccbdc638.png";